import { IBookingOptions } from "../model/BookingData";

export class FormView
{
	private readonly _formElement: HTMLFormElement;
	private readonly _textDateFrom: HTMLElement;
	private readonly _textDateTo: HTMLElement;
	private readonly _inputCheckIn: HTMLElement;
	private readonly _inputCheckOut: HTMLElement;
	private readonly _nightsDisplay: HTMLElement;

	constructor(element: HTMLElement,
		private readonly _options: IBookingOptions
	)
	{
		this._formElement = element.getElementsByTagName("form")[0];
		this._inputCheckIn = document.getElementsByName("check_in")[0];
		this._inputCheckOut = document.getElementsByName("check_out")[0];
		this._textDateFrom = document.getElementById("checkInDisplay");
		this._textDateTo = document.getElementById("checkOutDisplay");
		this._nightsDisplay = document.getElementById("nightsDisplay");

		this._formElement.onsubmit = () => this.onSubmit();
	}

	public reset(): void
	{
		this.update(null, null);
	}

	public update(from: Date | null, to: Date | null): void
	{
		if (from === null || to === null)
		{
			this._formElement.classList.add("invisible");
		}
		else
		{
			this._formElement.classList.remove("invisible");

			this._textDateFrom.innerText = from.toLocaleDateString(this._options.locale);
			this._textDateTo.innerText = to.toLocaleDateString(this._options.locale);

			const fromParts = [from.getFullYear(), from.getMonth() + 1, from.getDate()];
			const toParts = [to.getFullYear(), to.getMonth() + 1, to.getDate()];

			this._inputCheckIn.setAttribute("value", fromParts.join("-"));
			this._inputCheckOut.setAttribute("value", toParts.join("-"));

			const nights = (to.getTime() - from.getTime()) / (1000 * 60 * 60 * 24);

			this._nightsDisplay.innerHTML = nights + "";
		}
	}

	private onSubmit(): boolean
	{
		if (this._formElement.checkValidity())
		{
			document.getElementById("bookingFormSpinner").classList.remove("invisible");
			document.getElementById("bookingFormSubmitBtn").classList.add("invisible");

			const that = this;
			const xHttp = new XMLHttpRequest();
			xHttp.onload = function() { that.onRequestLoad(this); };
			xHttp.open("POST", location.href, true);
			xHttp.send(new FormData(this._formElement));
		}

		return false;
	}

	private onRequestLoad(req: XMLHttpRequest): void
	{
		document.getElementById("booking").innerHTML = req.responseText;
	}
}
